import { render, staticRenderFns } from "./Monitor.vue?vue&type=template&id=38ea359a&scoped=true"
import script from "./Monitor.vue?vue&type=script&setup=true&lang=js"
export * from "./Monitor.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Monitor.vue?vue&type=style&index=0&id=38ea359a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ea359a",
  null
  
)

export default component.exports